import { dbVersion } from '@office-start/edgeworth-data-service';
import { getDB, readAll, writeAll } from '@office-start/idb-cache';
import { deleteDB } from 'idb';
(function () {
    window.ewPreloadUserIdStorageKey = 'EwPreloadUserStorageId';
    window.ewDbVersion = dbVersion + (window.ewClientCacheServerOffset || 0);
    window.ewWorkload = window.ewWorkload || 'officehome';
    var db;
    var currentPuid;
    var allowDbAccess = true;
    var storeName = 'edgeworth-files';
    var getDb = function () {
        if (!allowDbAccess) {
            throw new Error('Database Access Not Allowed.');
        }
        if (db) {
            return Promise.resolve(db);
        }
        var dbName = "edgeworth-" + window.ewWorkload + "-" + currentPuid;
        var clearSyncTimestamps = function () {
            // Clear sync timestamps
            var oldKeys = [];
            for (var i = 0; i < localStorage.length; i++) {
                var key = localStorage.key(i);
                if (key.indexOf('_EdgeworthLastSyncTimestamp') >= 0 ||
                    key.indexOf("_Edgeworth" + window.ewWorkload + "LastSyncTimestamp") >= 0 ||
                    key.indexOf('_EdgeworthLastUiSyncTimestamp') >= 0) {
                    oldKeys.push(key);
                }
            }
            if (oldKeys.length) {
                oldKeys.forEach(function (key) { return localStorage.removeItem(key); });
            }
        };
        var innerGetDb = function () { return getDB(dbName, {
            upgrade: function (upgradeDb) {
                try {
                    upgradeDb.deleteObjectStore(storeName);
                    // Legacy Database Name didn't include workload, we need to delete those tables from the browser to save space.
                    var oldDbName = "edgeworth-" + currentPuid;
                    indexedDB.deleteDatabase(oldDbName);
                }
                catch ( /* Do nothing. */_a) { /* Do nothing. */ }
                var store = upgradeDb.createObjectStore(storeName);
                store.createIndex('useractions_date', 'useractions_datetime');
                store.createIndex('useractions_date_desc', 'useractions_datetime_inverse_time_in_ms');
                clearSyncTimestamps();
            },
            blocking: function () {
                // This callback fires when a new tab or window tries to open a newer version of the database,
                // but old versions in an existing tab are preventing upgrading of the database.
                // To workaround this, when a connection is blocking, we close the connection, and prevent
                // opening of any future connections.
                db === null || db === void 0 ? void 0 : db.close();
                allowDbAccess = false;
                if (window.ng2EventService) {
                    window.ng2EventService.broadcastEvent({
                        name: 'sessionExpired',
                        args: []
                    });
                }
            }
        }, window.ewDbVersion).then(function (resDb) {
            db = resDb;
            window.ewRcIdb = Promise.resolve(resDb);
            return db;
        }); };
        return innerGetDb().catch(function (e) {
            // Getting the database in Chromium browsers when there isn't enough storage will throw a connection closing exception.
            // See bug: https://bugs.chromium.org/p/chromium/issues/detail?id=146284
            // In Firefox 51-54, in Incognito, there is no way to open or modify an IndexedDB table, as it throws InvalidStateError.
            if (e.name === 'InvalidStateError') {
                allowDbAccess = false;
                return null;
            }
            // If requested version is less than the current DB version, browser throws DOMException, so we should delete current DB
            // and retry getDB operation. This can happen when we bump DB version but decided to roll back the build. In Chrome 48+/Firefox 58+,
            // DOMException gets returned instead of DOMError, and DOMError doesn't seem to have a specific error for this scenario
            // References: https://developer.mozilla.org/en-US/docs/Web/API/IDBRequest/error
            // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
            // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
            if ((e instanceof DOMException && e.name === 'VersionError') || (typeof (DOMError) !== undefined && e instanceof DOMError)) {
                // Also clear sync timestamp to ensure we do full delta sync request later
                clearSyncTimestamps();
                return deleteDB(dbName).then(innerGetDb);
            }
            return Promise.reject(e);
        });
    };
    window.ewIdb = {
        initDb: function (puid) {
            // Save user's PUID
            currentPuid = window.ewRcPuid = puid;
            db = null;
            allowDbAccess = true;
        },
        writeIntoCache: function (values) {
            if (!allowDbAccess) {
                return Promise.reject('Writes into IDB are not allowed.');
            }
            var keys = values.map(function (item) { return item.id; });
            return getDb().then(function (resDb) { return resDb ? writeAll(resDb, values, storeName, 'sync', keys) : null; });
        },
        readCache: function () {
            if (!allowDbAccess) {
                return Promise.reject('Reads from IDB are not allowed.');
            }
            return getDb().then(function (resDb) { return readAll(resDb, storeName); });
        },
        deleteItem: function (itemKey) {
            if (!allowDbAccess) {
                return Promise.reject('Deletes from IDB are not allowed.');
            }
            return getDb().then(function (resDb) { return resDb.delete(storeName, itemKey); });
        },
        eraseStore: function () {
            if (!allowDbAccess) {
                return Promise.reject('Deletes of a table in IDB are not allowed.');
            }
            return getDb().then(function (resDb) { return resDb.clear(storeName); });
        }
    };
    // "idb" library requires Proxy API.
    var hasProxyApi = 'Proxy' in window;
    if (hasProxyApi && localStorage[window.ewPreloadUserIdStorageKey]) {
        window.ewIdb.initDb(JSON.parse(localStorage[window.ewPreloadUserIdStorageKey]));
        var start_1 = performance.now();
        var getPreloadDuration_1 = function () {
            if (typeof (start_1) === 'number') {
                return performance.now() - start_1;
            }
            return undefined;
        };
        // Read the first few items from IndexedDB
        window.ewUserActionsPreloadData = window.ewRcPreloadData = getDb().then(function (resDb) {
            if (!allowDbAccess) {
                return [];
            }
            var currentDateInMilliseconds = (new Date()).getTime();
            var keyRange = IDBKeyRange.lowerBound(-currentDateInMilliseconds);
            return resDb.transaction(storeName, 'readonly').store.index('useractions_date_desc').getAll(keyRange, 15);
        });
        window.ewUserActionsPreloadData.then(function () {
            window.ewUserActionsPreloadDuration = getPreloadDuration_1();
            window.ewRcPreloadDuration = Promise.resolve(window.ewUserActionsPreloadDuration);
        });
    }
    else {
        window.ewUserActionsPreloadData = Promise.resolve(null);
    }
})();
